import { animate, timeline, stagger, inView, Delegate } from "{{ 'vendor.min.js' | asset_url }}";

(function (window, k) {

  var checkJqueryReady = function (callback) {
    if (window.jQuery) {
      callback(window.jQuery);
    } else {
      window.setTimeout(function () {
        checkJqueryReady(callback);
      }, 20);
    }
  };

  checkJqueryReady(function ($) {
    var jQuery = $;

   $(document).on('click', 'button.appstle-custom-add', function(event) {
      var $button = $(this);
      var $contentElement = $button.find('div');
      var $animationElement = $button.find('.button__loader');
      if(RSConfig?.customerId) {
        var selectedVariantId = $(this).closest('form[action$="/cart/add"]').find('[name=id]').val();
        $(this).removeClass("error");
        $(this).removeClass("success");
        $(this).addClass("inProgress");
        timeline2([
          [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
          [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
        ]);
        animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
        jQuery.get(`/${RSConfig.appstle_app_proxy_path_prefix}/cp/api/subscription-customers-detail/valid/${RSConfig.customerId}?token=${RSConfig.customerId}`, function(contractData) {
          if (contractData?.length) {
            window.appstleContractData = contractData;
            var customerActiveSubscriptions = contractData.filter((c) => c.status == 'active' || c.status == 'ACTIVE');

            if(customerActiveSubscriptions && customerActiveSubscriptions.length > 0) {
              var customerSubscription = customerActiveSubscriptions[0];
              const requestUrl = `/${RSConfig.appstle_app_proxy_path_prefix}/cp/api/v2/subscription-contracts-add-line-item?contractId=${customerSubscription?.subscriptionContractId}&quantity=${1}&variantId=gid://shopify/ProductVariant/${selectedVariantId}`;
              return jQuery.ajax({url: requestUrl, type: 'PUT'}).done((res) => {
                $(this).removeClass("inProgress");
                $(this).addClass("success");
                timeline2([
                  [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                  [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                ]);
                $contentElement.html('✔');
                setTimeout(() => {
                  $contentElement.html('+ Subscription');
                  $(this).removeClass("success");
                }, 2000);
              }).fail((err) => {
                $(this).removeClass("inProgress");
                $(this).addClass("error");
                timeline2([
                  [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                  [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                ]);
                $contentElement.html('✖');
                setTimeout(() => {
                  $contentElement.html('+ Add To Subscription');
                  $(this).removeClass("error");
                }, 2000);
              })
            }
          }
        })
        
      }
    })
  });

  $('#customer_login button').on('click', function() {
    fetch('/cart/clear.js', { method: 'POST' });
  });
    
})(window);